import React from "react";

import dollarIcon from "../../../../assets/images/performance/doller-icon.svg";
import personIcon from "../../../../assets/images/performance/person-star.svg";
import checkIcon from "../../../../assets/images/performance/eye-check.svg";

const formatCurrency = (value) =>
  `$${Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;

const formatNumber = (value) => Number(value || 0).toLocaleString("en-US");

const MetricSummaryRow = ({ metrics }) => {
  const items = [
    {
      key: "sales",
      label: "Estimated Sales",
      value: formatCurrency(metrics.estimated_sales),
      help: "Live estimate from tracked visitors and the active attendee value.",
      icon: dollarIcon,
    },
    {
      key: "visitors",
      label: "Ticket Page Visitors",
      value: formatNumber(metrics.ticket_page_visits),
      help: "Confirmed Vesta-tracked traffic to this event's ticket page.",
      icon: personIcon,
    },
    {
      key: "views",
      label: "Estimated Views",
      value: formatNumber(metrics.estimated_views),
      help: "Projected Vesta-driven visibility before those views become visits.",
      icon: checkIcon,
    },
  ];

  return (
    <div className="event-analytics-preview__metric-grid">
      {items.map((item) => (
        <article
          className={`event-analytics-preview__metric-card event-analytics-preview__metric-card--${item.key}`}
          key={item.label}
        >
          <div className="event-analytics-preview__metric-icon">
            <img alt="" aria-hidden="true" src={item.icon} />
          </div>

          <div className="event-analytics-preview__metric-content">
            <p className="event-analytics-preview__metric-label">{item.label}</p>
            <p className="event-analytics-preview__metric-value">{item.value}</p>
            <p className="event-analytics-preview__metric-help">{item.help}</p>
          </div>
        </article>
      ))}
    </div>
  );
};

export default MetricSummaryRow;
